import React from 'react';

import NavBar from '../../NavBar';
import NotesList from '../../NotesList';

const Notes = () => (
  <div>
    <NavBar />
    <NotesList />
  </div>
);

export default Notes;
